import { useTranslation } from 'react-i18next'

import { Spinner } from '../common'

interface PageProgressProps {
  current: number
  total: number
  loadMore: () => void
  isLoading: boolean
}

const PageProgress = ({
  current,
  total,
  loadMore,
  isLoading,
}: PageProgressProps) => {
  const { t } = useTranslation('casino')

  return (
    <div className="w-[173px] mt-6 mb-0 mx-auto v-flx-ctr">
      <span className="text-xs text-txt font-medium mb-1">
        {current} / {total}
      </span>
      <div className="bg-[#2e3748] h-2.5 relative w-full mb-3.5 rounded-[10px]">
        <div
          className="transition-all duration-[0.3s] ease-[ease-in-out] bg-[#46aef7] h-2.5 absolute rounded-[10px] left-0 top-0"
          style={{ width: `${(current / total) * 100}%` }}
        />
        <span className="text-[8px] leading-[10px] text-white font-medium w-full text-center absolute left-0 top-0">
          {Math.round((current / total) * 100)}%
        </span>
      </div>
      {isLoading ? (
        <Spinner containerStyle={{ height: 52 }} />
      ) : (
        <button
          className="w-full leading-[52px] text-base text-white font-bold bg-highlight rounded-[10px] hover:opacity-80"
          onClick={loadMore}>
          {t('load-more')}
        </button>
      )}
    </div>
  )
}

export default PageProgress
